import { overrideOxylinkAuthComponents } from './OxylinkAuth/OxylinkAuthComponents';
import { overrideOxylinkLogo } from './OxylinkLogo/OxylinkLogo';
import { overrideOxylinkNavBarItem } from './OxylinkNavBar/OxylinkNavBarItem/OxylinkNavBarItem';
import { overrideOxylinkNavBar } from './OxylinkNavBar/OxylinkNavBar';

export class OxylinkComponents {

    public static overrideComponents = () => {
        overrideOxylinkLogo();
        overrideOxylinkNavBar();
        overrideOxylinkNavBarItem();
        overrideOxylinkAuthComponents();
    };
}